import { api, MEMBER_API_SUB_URLS } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  RootState,
  MemberPersonalInformationResponseModel,
} from '@/@types/member';

interface PersonalInformationState {
  personalInformation: MemberPersonalInformationResponseModel;
}

const PERSONAL_INFORMATION_STATE: Module<
  PersonalInformationState,
  RootState
> = {
  state: {
    personalInformation: null,
  },
  actions: {
    // UC-REST-038 - Get Personal Information
    getPersonalInformation(context): Promise<AxiosResponse> {
      return api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/personal-info`, {
            params: {
              isViewUnmaskedSSN: false,
            },
          })
        .then((personalInformation) => {
          context.commit('setPersonalInformation', personalInformation.data);
        });
    },
    // UC-REST-039a - Update Mailing Address
    updateMailingAddress(context, options): Promise<AxiosResponse> {
      return api.put(
        `${MEMBER_API_SUB_URLS.members}/${
          context.getters.user.memberId
        }/profiles/addresses`,
        options,
      );
    },
    // UC-REST-039b - Update Phone Number
    updatePhoneNumber(context, options): Promise<AxiosResponse> {
      return api.put(
        `${MEMBER_API_SUB_URLS.members}/${
          context.getters.user.memberId
        }/profiles/phones`,
        options,
      );
    },
    // UC-REST-039c - Update Email Address
    updateEmailAddress(context, options): Promise<AxiosResponse> {
      return api.put(
        `${MEMBER_API_SUB_URLS.members}/${
          context.getters.user.memberId
        }/profiles/emails`,
        options,
      );
    },

    // UC-API-272
    validateAddress(): Promise<any> {
      return new Promise((resolve, reject) => {
        // eslint-disable-line no-undef, no-unused-vars
        setTimeout(() => {
          resolve({
            address: {
              addressLine1: 'KJEIAM',
              addressLine2: '',
              city: 'HALSTAD',
              state: 'MN',
              zipCode: '55068',
            },
            isNonUSAddress: false,
            nonUSAddressLine1: null,
            nonUSAddressLine2: null,
            nonUSAddressLine3: null,
            Certainty: 'Verified',
            Message: 'OK',
          });

          // reject({
          //   Addresses: [
          //     {
          //       MemberNonUSAddressIndicator: false,
          //       MemberAddr1: '1234 2nd St. NE',
          //       MemberAddr2: 'Apt 2',
          //       MemberCity: 'Minneapolis ',
          //       MemberState: 'MN',
          //       MemberZip: '55414',
          //       MemberNonUSAddr1: '',
          //       MemberNonUSAddr2: '',
          //       MemberNonUSAddr3: '',
          //     },
          //     {
          //       MemberNonUSAddressIndicator: false,
          //       MemberAddr1: '1234 2nd St.',
          //       MemberAddr2: '',
          //       MemberCity: 'St. Paul ',
          //       MemberState: 'MN',
          //       MemberZip: '55101',
          //       MemberNonUSAddr1: '',
          //       MemberNonUSAddr2: '',
          //       MemberNonUSAddr3: '',
          //     }
          //   ],
          //   Certainty: 'Multiple',
          //   Message: 'OK'
          // });

          // reject({
          //   Certainty: 'None',
          //   Message: 'OK'
          // });

          // reject({
          //   Matches: [
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //     '1…101 2nd St, Minneapolis, MN 55414 [odd]',
          //     '2…100 3rd St, Minneapolis, MN 55414 [even]',
          //   ],
          //   Certainty: 'StreetPartial',
          //   Message: 'OK'
          // });

          // reject({
          //   Address: {
          //     MemberNonUSAddressIndicator: false,
          //     MemberAddr1: '1234 2nd St.',
          //     MemberAddr2: '',
          //     MemberCity: 'St. Paul ',
          //     MemberState: 'MN',
          //     MemberZip: '55101',
          //     MemberNonUSAddr1: '',
          //     MemberNonUSAddr2: '',
          //     MemberNonUSAddr3: '',
          //   },
          //   Certainty: 'InteractionRequired',
          //   Message: 'OK'
          // });

          // reject({
          //   Addresses: [
          //     {
          //       MemberNonUSAddressIndicator: false,
          //       MemberAddr1: '1234 2nd St. NE',
          //       MemberAddr2: 'Apt 2',
          //       MemberCity: 'Minneapolis ',
          //       MemberState: 'MN',
          //       MemberZip: '55414',
          //       MemberNonUSAddr1: '',
          //       MemberNonUSAddr2: '',
          //       MemberNonUSAddr3: '',
          //     },
          //     {
          //       MemberNonUSAddressIndicator: false,
          //       MemberAddr1: '1234 2nd St.',
          //       MemberAddr2: '',
          //       MemberCity: 'St. Paul ',
          //       MemberState: 'MN',
          //       MemberZip: '55101',
          //       MemberNonUSAddr1: '',
          //       MemberNonUSAddr2: '',
          //       MemberNonUSAddr3: '',
          //     }
          //   ],
          //   Certainty: 'PremisesPartial',
          //   Message: 'OK'
          // });
        }, 1500);
      });
    },
  },
  mutations: {
    setPersonalInformation(
      state: PersonalInformationState,
      data: MemberPersonalInformationResponseModel,
    ) {
      const MODEL = {
        address: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          state: null,
          zipCode: null,
        },
        isNonUSAddress: null,
        nonUSAddress: {
          nonUSAddressLine1: null,
          nonUSAddressLine2: null,
          nonUSAddressLine3: null,
        },
        primaryPhone: {
          areaCode: null,
          exchangeCode: null,
          lineNumber: null,
          extension: null,
        },
        isMobilePrimary: null,
        alternatePhone: {
          areaCode: null,
          exchangeCode: null,
          lineNumber: null,
          extension: null,
        },
        isMobileAlternate: null,
        email: null,
        dateOfBirth: null,
        healthPlanId: null,
        gender: null,
        locationId: null,
        employeeNumber: null,
        department: null,
        lastName: null,
        firstName: null,
        middleInitial: null,
        locationName: null,
        ssn: null,
        caseNumber: null,
      };

      data = Object.assign(MODEL, data);

      state.personalInformation = data;
    },
  },
  getters: {
    personalInformation(state): MemberPersonalInformationResponseModel {
      return state.personalInformation;
    },
  },
};

export default PERSONAL_INFORMATION_STATE;
